import { apiClient } from '@/services/api'

// Admin view + CRUD for GloboGraphics sites/zones, backed by /sites. A
// site is a DB entity (identity + non-secret connection config). Endpoints carry
// only a base URL — there are no per-endpoint credentials; the Graphic Hub
// credential is a single global backend env var. Distinct from the `sites` module,
// which feeds the picker (/sites/producao/:cod). Keyed by sigla.

const state = () => ({
    sites: [],
    loading: false,
    lastError: null,
})

const getters = {
    getterAdminSites: state => state.sites,
    getterAdminSitesLoading: state => state.loading,
    getterAdminSitesError: state => state.lastError,
}

function describeError(error, fallback) {
    return error?.response?.data?.error || fallback
}

const actions = {
    async fetchSites({ commit }) {
        commit('setLoading', true)
        commit('setLastError', null)
        try {
            const { data } = await apiClient.get('sites')
            commit('setSites', Array.isArray(data) ? data : [])
            return data
        } catch (error) {
            commit('setLastError', describeError(error, 'Erro ao carregar sites'))
            throw error
        } finally {
            commit('setLoading', false)
        }
    },

    // --- Site CRUD (identity + non-secret MSE config) ---
    async createSite({ dispatch }, payload) {
        const { data } = await apiClient.post('sites', payload)
        await dispatch('fetchSites')
        return data
    },
    async updateSite({ dispatch }, { sigla, ...payload }) {
        const { data } = await apiClient.put(`sites/${encodeURIComponent(sigla)}`, payload)
        await dispatch('fetchSites')
        return data
    },
    async deleteSite({ dispatch }, sigla) {
        await apiClient.delete(`sites/${encodeURIComponent(sigla)}`)
        await dispatch('fetchSites')
    },

    // Onboarding: create a template show on this site's MSE (Trio-less) and
    // persist its GUID. Returns { templateShowName, templateShowGuid }.
    async provisionTemplateShow({ dispatch }, sigla) {
        const { data } = await apiClient.post(`sites/${encodeURIComponent(sigla)}/provision-template-show`)
        await dispatch('fetchSites')
        return data
    },

    // --- Endpoint sub-CRUD (PDS / GloboGraphics / Preview; base url only) ---
    async createEndpoint({ dispatch }, { sigla, ...payload }) {
        const { data } = await apiClient.post(`sites/${encodeURIComponent(sigla)}/endpoints`, payload)
        await dispatch('fetchSites')
        return data
    },
    async updateEndpoint({ dispatch }, { sigla, id, ...payload }) {
        const { data } = await apiClient.put(`sites/${encodeURIComponent(sigla)}/endpoints/${id}`, payload)
        await dispatch('fetchSites')
        return data
    },
    async deleteEndpoint({ dispatch }, { sigla, id }) {
        await apiClient.delete(`sites/${encodeURIComponent(sigla)}/endpoints/${id}`)
        await dispatch('fetchSites')
    },
}

const mutations = {
    setSites: (state, sites) => { state.sites = sites },
    setLoading: (state, loading) => { state.loading = loading },
    setLastError: (state, msg) => { state.lastError = msg },
}

export default { namespaced: true, state, getters, actions, mutations }
